import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  const persist = (token, u, t) => {
    localStorage.setItem("prophr_token", token);
    localStorage.setItem("prophr_user", JSON.stringify(u));
    if (t) localStorage.setItem("prophr_tenant", JSON.stringify(t));
    setUser(u);
    setTenant(t || null);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data.token, data.user, data.tenant);
    return data;
  };

  const register = async (email, name, password, tenant_slug) => {
    const { data } = await api.post("/auth/register", { email, name, password, tenant_slug });
    persist(data.token, data.user, data.tenant);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("prophr_token");
    localStorage.removeItem("prophr_user");
    localStorage.removeItem("prophr_tenant");
    setUser(null);
    setTenant(null);
  };

  const refreshMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      persist(data.token, data.user, data.tenant);
      return data;
    } catch {
      logout();
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("prophr_token");
    const stored = localStorage.getItem("prophr_user");
    const storedT = localStorage.getItem("prophr_tenant");
    if (token && stored) {
      try {
        setUser(JSON.parse(stored));
        setTenant(storedT ? JSON.parse(storedT) : null);
        refreshMe().finally(() => setLoading(false));
      } catch {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthCtx.Provider value={{ user, tenant, loading, login, register, logout, refreshMe }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);

export const homeForRole = (role) => {
  switch (role) {
    case "super_admin": return "/super";
    case "company_admin": return "/admin";
    case "hr": return "/hr";
    case "manager": return "/manager";
    default: return "/dashboard";
  }
};
